export default "/assets/webpack-assets/GT-Walsheim-Pro-Bold-Oblique.d1bad8c4cc743c3129b22d1923a328fb.ttf";